import React from 'react';
import { Form, Radio } from 'antd';
import { I18n } from '@aws-amplify/core';

const { useFormInstance, useWatch } = Form;

const HAS_KNOWN_INJURY_FIELD = 'has_known_injury';
const NO_RISK_FIELD = 'has_no_risk';

interface HasKnownInjuryProps {
	fileId: string;
}

export function HasKnownInjury({ fileId }: Readonly<HasKnownInjuryProps>): JSX.Element {
	const form = useFormInstance();

	const hasNoRisk: boolean = useWatch([fileId, NO_RISK_FIELD], form) ?? false;

	const options = [
		{ value: true, label: I18n.get('Yes') },
		{ value: false, label: I18n.get('No') }
	];

	return (
		<Form.Item
			name={[fileId, HAS_KNOWN_INJURY_FIELD]}
			label={I18n.get('Has known injury?')}
			labelCol={{ span: 24 }}
			rules={[{ required: true, message: I18n.get('Select an option') }]}
		>
			<Radio.Group options={options} disabled={hasNoRisk} />
		</Form.Item>
	);
}
